import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HeaderLinkComponent } from './header-link/header-link.component';

@Component({
  selector: 'app-home-link',
  standalone: true,
  imports: [CommonModule, MatIconModule, HeaderLinkComponent],
  template: `
    <app-header-link [caption]="name" icon="home_icon" [link]="['/', 'customer-spaces', this.customerSpaceId]" />
  `,
})
export class HomeLinkComponent {
  @Input() name: string;
  @Input() customerSpaceId: string;
}
